import { BrowserRouter, Routes, Route } from "react-router-dom";

import Homepage from "./pages/homepage.jsx";
import LoginPage from "./pages/auth/login.jsx";
import DriversAnalyticsPage from "./pages/analytics/drivers.jsx";
import RidesAnalyticsPage from "./pages/analytics/rides.jsx";
import MetricsReportPage from "./pages/analytics/metrics-report.jsx";
import AddUserPage from "./pages/db/users/add.jsx";
import VehicleAssignmentPage from "./pages/db/vehicle-assignments.jsx";
import NotFoundPage from "./pages/not-found.jsx";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/auth/login" element={<LoginPage />} />
        <Route path="/analytics/drivers" element={<DriversAnalyticsPage />} />
        <Route path="/analytics/rides" element={<RidesAnalyticsPage />} />
        <Route path="/analytics/metrics-report" element={<MetricsReportPage />} />
        <Route path="/db/users/add" element={<AddUserPage />} />
        <Route path="/db/vehicle-assignments" element={<VehicleAssignmentPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </BrowserRouter>
  );
}
